module.exports = __webpack_public_path__ + "img/242.15fd17ac.jpg";